import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { CustomFieldsModule } from '@freelancer/custom-fields';
import {
  DatastoreArticlesModule,
  DatastoreCanViewEmployerProfileModule,
  DatastoreCertificationsModule,
  DatastoreCountriesModule,
  DatastoreEducationsModule,
  DatastoreEmployerReputationsRehireRatesModule,
  DatastoreExperiencesModule,
  DatastoreFreelancerReputationsRehireRatesModule,
  DatastoreMembershipBenefitsModule,
  DatastoreNextPreviousUsersModule,
  DatastoreProfileCategoriesModule,
  DatastoreProfileViewUsersModule,
  DatastoreProjectsModule,
  DatastoreProjectViewUsersModule,
  DatastorePublicationsModule,
  DatastoreReviewsModule,
  DatastoreReviewsSkillsModule,
  DatastoreShowcaseModule,
  DatastoreSimilarFreelancersModule,
  DatastoreSimilarShowcasesModule,
  DatastoreTopSkillsModule,
  DatastoreUniversitiesModule,
  DatastoreUserInfoModule,
  DatastoreUserInsigniasModule,
} from '@freelancer/datastore/collections';
import { DirectivesModule } from '@freelancer/directives';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui/ui.module';
import { ViewHeaderTemplateModule } from '@freelancer/view-header-template';
import { DiscoverPortfolioItemCardModule } from 'app/discover/discover-portfolio-item-card/discover-portfolio-item-card.module';
import { FooterModule } from 'app/footer/footer.module';
import { HireMeModule } from 'app/hire-me/hire-me.module';
import { BannersModule } from '../banners/banners.module';
import { NavigationSecondarySkillsModule } from '../navigation/navigation-secondary-skills/navigation-secondary-skills.module';
import { NavigationSecondaryProfileModule } from '../navigation/navigation-secondary/navigation-secondary-profile.module';
import { UserPortfolioModule } from '../projects/project-view/user-profile-information/user-portfolio/user-portfolio.module';
import { UserProfileInformationModule } from '../projects/project-view/user-profile-information/user-profile-information.module';
import { ReviewsModule } from '../reviews/reviews.module';
import { UserProfileAccountClosedComponent } from './user-profile-account-closed/user-profile-account-closed.component';
import { UserProfileArticlesItemComponent } from './user-profile-articles/user-profile-articles-item/user-profile-articles-item.component';
import { UserProfileArticlesComponent } from './user-profile-articles/user-profile-articles.component';
import { UserProfileAwardProjectBannerComponent } from './user-profile-award-project-banner/user-profile-award-project-banner.component';
import { UserProfileAwardProjectSidebarComponent } from './user-profile-award-project-sidebar/user-profile-award-project-sidebar.component';
import { UserProfileBannerComponent } from './user-profile-banner/user-profile-banner.component';
import { UserProfileBreadcrumbsComponent } from './user-profile-breadcrumbs/user-profile-breadcrumbs.component';
import { UserProfileBrowseFreelancersComponent } from './user-profile-browse-freelancers/user-profile-browse-freelancers.component';
import { UserProfileBrowseShowcasesComponent } from './user-profile-browse-showcases/user-profile-browse-showcases.component';
import { UserProfileEditCoverPictureComponent } from './user-profile-edit-cover-picture/user-profile-edit-cover-picture.component';
import { UserProfileEditableUiModule } from './user-profile-editable-ui/user-profile-editable-ui.module';
import { UserProfileExamsComponent } from './user-profile-exams/user-profile-exams.component';
import { UserProfileFooterComponent } from './user-profile-footer/user-profile-footer.component';
import { UserProfileHeaderComponent } from './user-profile-header/user-profile-header.component';
import { UserProfileHireMeActionStateModule } from './user-profile-hire-me-action-state/user-profile-hire-me-action-state.module';
import { UserProfileHireMeActionComponent } from './user-profile-hire-me-action/user-profile-hire-me-action.component';
import { UserProfileHireMeComponent } from './user-profile-hire-me/user-profile-hire-me.component';
import { UserProfileLoggedOutLinkModule } from './user-profile-logged-out-link/user-profile-logged-out-link.module';
import { UserProfileNextPreviousUsersComponent } from './user-profile-next-previous-users/user-profile-next-previous-users.component';
import { UserProfilePictureSelectorModule } from './user-profile-picture/user-profile-picture-selector/user-profile-picture-selector.module';
import { UserProfilePictureModule } from './user-profile-picture/user-profile-picture.module';
import { UserProfilePortfolioComponent } from './user-profile-portfolio/user-profile-portfolio.component';
import { UserProfileReportComponent } from './user-profile-report/user-profile-report.component';
import { UserProfileCertificationsEditComponent } from './user-profile-resume/user-profile-certifications/user-profile-certifications-edit/user-profile-certifications-edit.component';
import { UserProfileCertificationsViewComponent } from './user-profile-resume/user-profile-certifications/user-profile-certifications-view/user-profile-certifications-view.component';
import { UserProfileCertificationsComponent } from './user-profile-resume/user-profile-certifications/user-profile-certifications.component';
import { UserProfileEducationsModule } from './user-profile-resume/user-profile-educations/user-profile-educations.module';
import { UserProfileExperiencesModule } from './user-profile-resume/user-profile-experiences/user-profile-experiences.module';
import { UserProfileExpertCommunitiesBadgeComponent } from './user-profile-resume/user-profile-expert-communities/user-profile-expert-communities-badge/user-profile-expert-communities-badge.component';
import { UserProfileExpertCommunitiesComponent } from './user-profile-resume/user-profile-expert-communities/user-profile-expert-communities.component';
import { UserProfilePractitionerInformationModule } from './user-profile-resume/user-profile-practitioner-information/user-profile-practitioner-information.module';
import { UserProfilePublicationsEditComponent } from './user-profile-resume/user-profile-publications/user-profile-publications-edit/user-profile-publications-edit.component';
import { UserProfilePublicationsViewComponent } from './user-profile-resume/user-profile-publications/user-profile-publications-view/user-profile-publications-view.component';
import { UserProfilePublicationsComponent } from './user-profile-resume/user-profile-publications/user-profile-publications.component';
import { UserProfileReviewsFilterComponent } from './user-profile-reviews/user-profile-reviews-filter/user-profile-reviews-filter.component';
import { UserProfileReviewsComponent } from './user-profile-reviews/user-profile-reviews.component';
import { UserProfileRoutingModule } from './user-profile-routing.module';
import { UserProfileShowcaseComponent } from './user-profile-showcase/user-profile-showcase.component';
import { UserProfileSkillsEmptyComponent } from './user-profile-skills/user-profile-skills-empty/user-profile-skills-empty.component';
import { UserProfileSkillsItemComponent } from './user-profile-skills/user-profile-skills-item/user-profile-skills-item.component';
import { UserProfileSkillsComponent } from './user-profile-skills/user-profile-skills.component';
import { UserProfileSummaryModule } from './user-profile-summary/user-profile-summary.module';
import { UserProfileSwitchViewsComponent } from './user-profile-switch-views/user-profile-switch-views.component';
import { UserProfileVerificationItemComponent } from './user-profile-verifications/user-profile-verification-item/user-profile-verification-item.component';
import { UserProfileVerificationsComponent } from './user-profile-verifications/user-profile-verifications.component';
import { UserProfileWrapperComponent } from './user-profile-wrapper/user-profile-wrapper.component';
import { UserProfileComponent } from './user-profile.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CustomFieldsModule,
    DatastoreArticlesModule,
    DatastoreCertificationsModule,
    DatastoreCountriesModule,
    DatastoreEducationsModule,
    DatastoreEmployerReputationsRehireRatesModule,
    DatastoreExperiencesModule,
    DatastoreFreelancerReputationsRehireRatesModule,
    DatastoreMembershipBenefitsModule,
    DatastoreNextPreviousUsersModule,
    DatastoreProfileCategoriesModule,
    DatastoreProfileViewUsersModule,
    DatastoreProjectsModule,
    DatastoreProjectViewUsersModule,
    DatastorePublicationsModule,
    DatastoreReviewsModule,
    DatastoreReviewsSkillsModule,
    DatastoreShowcaseModule,
    DatastoreSimilarFreelancersModule,
    DatastoreSimilarShowcasesModule,
    DatastoreTopSkillsModule,
    DatastoreUniversitiesModule,
    DatastoreCanViewEmployerProfileModule,
    DatastoreUserInfoModule,
    DatastoreUserInsigniasModule,
    DirectivesModule,
    DiscoverPortfolioItemCardModule,
    FeatureFlagsModule,
    FooterModule,
    HireMeModule,
    NavigationSecondaryProfileModule,
    PipesModule,
    ReviewsModule,
    TrackingModule,
    UiModule,
    BannersModule,
    UserPortfolioModule,
    UserProfileEditableUiModule,
    UserProfileEducationsModule,
    UserProfileExperiencesModule,
    UserProfileHireMeActionStateModule,
    UserProfilePractitionerInformationModule,
    UserProfileInformationModule,
    UserProfileLoggedOutLinkModule,
    NavigationSecondarySkillsModule,
    UserProfilePictureSelectorModule,
    UserProfileRoutingModule,
    UserProfileSummaryModule,
    UserProfilePictureModule,
    ViewHeaderTemplateModule,
  ],
  declarations: [
    UserProfileAccountClosedComponent,
    UserProfileArticlesComponent,
    UserProfileArticlesItemComponent,
    UserProfileAwardProjectBannerComponent,
    UserProfileAwardProjectSidebarComponent,
    UserProfileBrowseFreelancersComponent,
    UserProfileBrowseShowcasesComponent,
    UserProfileCertificationsComponent,
    UserProfileCertificationsEditComponent,
    UserProfileCertificationsViewComponent,
    UserProfileComponent,
    UserProfileEditCoverPictureComponent,
    UserProfileExamsComponent,
    UserProfileExpertCommunitiesComponent,
    UserProfileExpertCommunitiesBadgeComponent,
    UserProfileFooterComponent,
    UserProfileHeaderComponent,
    UserProfileHireMeActionComponent,
    UserProfileHireMeComponent,
    UserProfileNextPreviousUsersComponent,
    UserProfilePortfolioComponent,
    UserProfilePublicationsComponent,
    UserProfilePublicationsEditComponent,
    UserProfilePublicationsViewComponent,
    UserProfileReportComponent,
    UserProfileReviewsComponent,
    UserProfileShowcaseComponent,
    UserProfileSkillsComponent,
    UserProfileSkillsEmptyComponent,
    UserProfileSkillsItemComponent,
    UserProfileSwitchViewsComponent,
    UserProfileVerificationItemComponent,
    UserProfileVerificationsComponent,
    UserProfileWrapperComponent,
    UserProfileBreadcrumbsComponent,
    UserProfileBannerComponent,
    UserProfileReviewsFilterComponent,
  ],
})
export class UserProfileModule {}
